export default "__VITE_ASSET__7e24e40f__"